import React, { useEffect, useState } from "react";
import api from 'api';

const CacheArrange = () => {

    const idx = 5;

  console.log("userTabMemoidx: ", idx);

  const [yen, setYen] = useState({
    y10000: 0,
    y5000: 0,
    y2000: 0,
    y1000: 0,
    y500: 0,
    y100: 0,
    y50: 0,
    y10: 0,
    y5: 0,
    y1: 0
  });

  const setYenValue = (event) => {
    const { value, name } = event.target;
    //setMemo({...memo, [name]: value});
    setYen({...yen, [name]: value});
  }

//   const submitMemo = async () => {
//     console.log("memo.userIdx: ", memo);
//     const resp = await (await api.post(apiUrl + '/user/memo/' + idx, memo)).data;
//     setTimeout(getUserMemo, 1000);
//   }

//   const getUserMemo = async () => {
//     console.log("userMemoApiUrl: ", apiUrl + '/user/memo/' + idx);
//     const resp = await api.get(apiUrl + '/user/memo/' + idx)).data;
//     console.log("memoResp", resp);
//     setUserMemoList(resp);
//   };

  useEffect(() => {
    //getUserMemo();
  }, []);

  return(
    <>



      <div class="row">




        <div class="col-lg-6">

          <div class="card">
            <div class="card-body">
              <h5 class="card-title">キャッシュ·ドローア</h5>

                <div class="row mb-3">
                  <label for="inputNumber" class="col-sm-4 col-form-label">日万円札</label>
                  <div class="col-sm-4" style={{textAlign:"right"}}>
                    <input type="number" name="y10000" defaultValue={yen.y10000} onChange={setYenValue} class="form-control" style={{textAlign:"right", width:100, float:"left"}} />枚
                  </div>
                  <div class="col-sm-4" style={{textAlign:"right"}}>
                    ￥{yen.y10000 * 10000}
                  </div>
                </div>

                <div class="row mb-3">
                  <label for="inputNumber" class="col-sm-4 col-form-label">五千円札</label>
                  <div class="col-sm-4" style={{textAlign:"right"}}>
                    <input type="number" name="y5000" defaultValue={yen.y5000} onChange={setYenValue} class="form-control" style={{textAlign:"right", width:100, float:"left"}} />枚
                  </div>
                  <div class="col-sm-4" style={{textAlign:"right"}}>
                    ￥{yen.y5000 * 5000}
                  </div>
                </div>

                <div class="row mb-3">
                  <label for="inputNumber" class="col-sm-4 col-form-label">二千円札</label>
                  <div class="col-sm-4" style={{textAlign:"right"}}>
                    <input type="number" name="y2000" defaultValue={yen.y2000} onChange={setYenValue} class="form-control" style={{textAlign:"right", width:100, float:"left"}} />枚
                  </div>
                  <div class="col-sm-4" style={{textAlign:"right"}}>
                    ￥{yen.y2000 * 2000}
                  </div>
                </div>

                <div class="row mb-3">
                  <label for="inputNumber" class="col-sm-4 col-form-label">一千円札</label>
                  <div class="col-sm-4" style={{textAlign:"right"}}>
                    <input type="number" name="y1000" defaultValue={yen.y1000} onChange={setYenValue} class="form-control" style={{textAlign:"right", width:100, float:"left"}} />枚
                  </div>
                  <div class="col-sm-4" style={{textAlign:"right"}}>
                    ￥{yen.y1000 * 1000}
                  </div>
                </div>

                <div class="row mb-3">
                  <label for="inputNumber" class="col-sm-4 col-form-label">500円硬貨</label>
                  <div class="col-sm-4" style={{textAlign:"right"}}>
                    <input type="number" name="y500" defaultValue={yen.y500} onChange={setYenValue} class="form-control" style={{textAlign:"right", width:100, float:"left"}} />枚
                  </div>
                  <div class="col-sm-4" style={{textAlign:"right"}}>
                    ￥{yen.y500 * 500}
                  </div>
                </div>

                <div class="row mb-3">
                  <label for="inputNumber" class="col-sm-4 col-form-label">100円硬貨</label>
                  <div class="col-sm-4" style={{textAlign:"right"}}>
                    <input type="number" name="y100" defaultValue={yen.y100} onChange={setYenValue} class="form-control" style={{textAlign:"right", width:100, float:"left"}} />枚
                  </div>
                  <div class="col-sm-4" style={{textAlign:"right"}}>
                    ￥{yen.y100 * 100}
                  </div>
                </div>

                <div class="row mb-3">
                  <label for="inputNumber" class="col-sm-4 col-form-label">50円硬貨</label>
                  <div class="col-sm-4" style={{textAlign:"right"}}>
                    <input type="number" name="y50" defaultValue={yen.y50} onChange={setYenValue} class="form-control" style={{textAlign:"right", width:100, float:"left"}} />枚
                  </div>
                  <div class="col-sm-4" style={{textAlign:"right"}}>
                    ￥{yen.y50 * 50}
                  </div>
                </div>

                <div class="row mb-3">
                  <label for="inputNumber" class="col-sm-4 col-form-label">10円硬貨</label>
                  <div class="col-sm-4" style={{textAlign:"right"}}>
                    <input type="number" name="y10" defaultValue={yen.y10} onChange={setYenValue} class="form-control" style={{textAlign:"right", width:100, float:"left"}} />枚
                  </div>
                  <div class="col-sm-4" style={{textAlign:"right"}}>
                    ￥{yen.y10 * 10}
                  </div>
                </div>

                <div class="row mb-3">
                  <label for="inputNumber" class="col-sm-4 col-form-label">5円硬貨</label>
                  <div class="col-sm-4" style={{textAlign:"right"}}>
                    <input type="number" name="y5" defaultValue={yen.y5} onChange={setYenValue} class="form-control" style={{textAlign:"right", width:100, float:"left"}} />枚
                  </div>
                  <div class="col-sm-4" style={{textAlign:"right"}}>
                    ￥{yen.y5 * 5}
                  </div>
                </div>

                <div class="row mb-3">
                  <label for="inputNumber" class="col-sm-4 col-form-label">1円硬貨</label>
                  <div class="col-sm-4" style={{textAlign:"right"}}>
                    <input type="number" name="y1" defaultValue={yen.y1} onChange={setYenValue} class="form-control" style={{textAlign:"right", width:100, float:"left"}} />枚
                  </div>
                  <div class="col-sm-4" style={{textAlign:"right"}}>
                    ￥{yen.y5 * 5}
                  </div>
                </div>

            </div>
          </div>

        </div>

{/*
단말 매출
거스름돈 준비금
현금 매출
크레딧 매출
기타 매출
예금
보관금 환불
입금
출금

계산 현금 잔액
실현금잔고
현금이 부족합니다
은행 예금
이월 준비금
*/}


        <div class="col-lg-6">

          <div class="card">
            <div class="card-body">
              <h5 class="card-title">端末売上(단말매출)</h5>

                <div class="row mb-3">
                  <div class="col-sm-6">釣銭準備金(거스름돈 준비금)</div>
                  <div class="col-sm-6" style={{textAlign:"right"}}>￥ 0</div>
                </div>

                <div class="row mb-3">
                  <div class="col-sm-6">&nbsp;&nbsp;&nbsp;現金売上(현금매출)</div>
                  <div class="col-sm-6" style={{textAlign:"right"}}>￥ 0</div>
                </div>
                {/*<div class="row mb-3">
                  <div class="col-sm-6">&nbsp;&nbsp;&nbsp;クレジット売上(크레딧매출)</div>
                  <div class="col-sm-6" style={{textAlign:"right"}}>￥ 0</div>
                </div>
                <div class="row mb-3">
                  <div class="col-sm-6">&nbsp;&nbsp;&nbsp;その他売上(기타매출)</div>
                  <div class="col-sm-6" style={{textAlign:"right"}}>￥ 0</div>
                </div>
                <div class="row mb-3">
                  <div class="col-sm-6">&nbsp;&nbsp;&nbsp;預かり金(예치금)</div>
                  <div class="col-sm-6" style={{textAlign:"right"}}>￥ 0</div>
                </div>
                <div class="row mb-3">
                  <div class="col-sm-6">&nbsp;&nbsp;&nbsp;預かり金返金(예치금환불)</div>
                  <div class="col-sm-6" style={{textAlign:"right"}}>￥ 0</div>
                </div>*/}
                <div class="row mb-3">
                  <div class="col-sm-6">&nbsp;&nbsp;&nbsp;入金(입금)</div>
                  <div class="col-sm-6" style={{textAlign:"right"}}>
                    <input type="number" name="aaa" defaultValue={0} onChange={setYenValue} class="form-control" style={{textAlign:"right"}} />
                  </div>
                </div>
                <div class="row mb-3">
                  <div class="col-sm-6">&nbsp;&nbsp;&nbsp;出金(출금)</div>
                  <div class="col-sm-6" style={{textAlign:"right"}}>
                    <input type="number" name="aaa" defaultValue={0} onChange={setYenValue} class="form-control" style={{textAlign:"right"}} />
                  </div>
                </div>

                {/*<div class="row mb-3">
                  <div class="col-sm-6">計算現金残高(현금계산잔고)</div>
                  <div class="col-sm-6" style={{textAlign:"right"}}>￥ 0</div>
                </div>
                <div class="row mb-3">
                  <div class="col-sm-6">実現金残高(실제현금잔액)</div>
                  <div class="col-sm-6" style={{textAlign:"right"}}>￥ 0</div>
                </div>*/}
                <div class="row mb-3">
                  <div class="col-sm-6">現金が不足(부족현금)</div>
                  <div class="col-sm-6" style={{textAlign:"right"}}>￥ 0</div>
                </div>
                {/*<div class="row mb-3">
                  <div class="col-sm-6">繰越準備金(이월준비금)</div>
                  <div class="col-sm-6" style={{textAlign:"right"}}>￥ 0</div>
                </div>
                <div class="row mb-3">
                  <div class="col-sm-6">銀行預金(은행예금)出金(출금)</div>
                  <div class="col-sm-6" style={{textAlign:"right"}}>
                    <input type="number" name="aaa" defaultValue={0} onChange={setYenValue} class="form-control" style={{textAlign:"right"}} />
                  </div>
                </div>*/}

                <br /><br />

                <div class="row mb-3">
                  <div class="col-sm-12">
                    <textarea class="form-control" style={{height:"100px"}} placeholder="메모를 넣어주세요">
                    </textarea>
                  </div>
                </div>

                <div class="d-grid gap-2 mt-3">
                <button class="btn btn-primary" type="button">confirm</button>
              </div>


            </div>
          </div>



        </div>
      </div>
    </>
  );
}

export default CacheArrange;







